export type AppUpdatePlatform = 'PlayStore' | 'DirectApk';

/** Which mobile app a config applies to. Gari configs are app-wide (no insurer). */
export type MobileApp = 'AgentsApp' | 'ClientsApp' | 'GariApp';

export const MOBILE_APP_LABELS: Record<MobileApp, string> = {
  AgentsApp: 'Agents app',
  ClientsApp: 'Clients app',
  GariApp: 'Gari',
};

export interface IAppUpdateConfigInsurer {
  id: number;
  name: string;
  shortName: string;
  logoUrl: string;
}

export interface IAppUpdateConfig {
  id: string;
  insurerId: number | null;
  insurer: IAppUpdateConfigInsurer | null;
  app: MobileApp;
  platform: AppUpdatePlatform;
  minSupportedVersion: string;
  latestVersion: string;
  apkUrl: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface IAppUpdateConfigCreateRequest {
  insurerId: number | null;
  app: MobileApp;
  platform: AppUpdatePlatform;
  minSupportedVersion: string;
  latestVersion: string;
  apkUrl: string | null;
}

export interface IAppUpdateConfigUpdateRequest {
  platform: AppUpdatePlatform;
  minSupportedVersion: string;
  latestVersion: string;
  apkUrl: string | null;
}
